import React from "react";
import { RouterProvider } from "react-router-dom";
import RouterConfig from "./routerConfig";
import "./app.css";

const router = RouterConfig;

function App() {
  return <RouterProvider router={router} />;
}

export default App;
